module.exports = __webpack_public_path__ + "static/media/politica_de_privacidad.934f8719.pdf";